export const Product = {
	PLAN: "plan",
	MICRO_SERVICE: "micro_service",
};

export const ID_TERM_TRADEMAP = 3;
